export const UNREAD_COUNT = {
  MAX_DISPLAY: 9,
  MAX_DISPLAY_TEXT: '9+',
} as const

/** Default delay before search input triggers URL updates or API calls. */
export const SEARCH_DEBOUNCE_MS = 300

// OPTIMIZATION: Removed CHAT_REFRESH_INTERVALS since we no longer use intervals
// Unread counts are now fetched only when needed (page visit, user auth, etc.)
